import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { useIntl } from 'umi';

function generateList(list: any[], valuesToGet: string[]) {
  return valuesToGet.map((value) => {
    return list?.find((item) => item.value === value);
  });
}

export const useCompanyOptionList = (params: any = {}) => {
  const { formatMessage } = useIntl();

  const gamesStatsOptions = [
    {
      text: formatMessage({ id: `dbi_company_mobile_metrics` }),
      value: 'mobile',
      subOptions: [
        { text: formatMessage({ id: `dbi_revenue` }), value: 'revenue' },
        { text: formatMessage({ id: `dbi_downloads` }), value: 'downloads' },
      ],
    },
    {
      text: formatMessage({ id: `dbi_company_pc_metrics` }),
      value: 'pc',
      subOptions: [
        {
          text: formatMessage({ id: `dbi_digital_revenue` }),
          value: 'digitalRevenue',
        },
        {
          text: formatMessage({ id: `dbi_physical_revenue` }),
          value: 'physicalRevenue',
        },
        { text: formatMessage({ id: `dbi_pcu` }), value: 'pcu' },
        { text: formatMessage({ id: `dbi_mau` }), value: 'mau' },
      ],
    },
    {
      text: formatMessage({ id: `dbi_company_console_metrics` }),
      value: 'console',
      subOptions: [
        {
          text: formatMessage({ id: `dbi_digital_revenue` }),
          value: 'digitalRevenue',
        },
        {
          text: formatMessage({ id: `dbi_physical_revenue` }),
          value: 'physicalRevenue',
        },
        { text: formatMessage({ id: `dbi_mau` }), value: 'mau' },
      ],
    },
    {
      text: formatMessage({ id: `dbi_company_game_owned` }),
      value: 'gamesOwned',
    },
  ];

  const revenueDownloadList = [
    {
      title: formatMessage({ id: `dbi_revenue_$` }),
      value: 'revenue',
      width: 200,
      width_cn: 200,
      renderType: RenderType.VALUE_AND_RATIO,
      textContent: formatMessage({ id: `dbi_info_sum_selected` }),
    },
    {
      title: formatMessage({ id: `dbi_downloads` }),
      value: 'download',
      width: 200,
      width_cn: 200,
      renderType: RenderType.VALUE_AND_RATIO,
      textContent: formatMessage({ id: `dbi_info_sum_selected` }),
    },
    {
      title: formatMessage({ id: `dbi_company_revenue$_company` }),
      value: 'revenue_company',
      width: 275,
      width_cn: 275,
      renderType: RenderType.GROWTH_ONLY,
      textContent: formatMessage({ id: `dbi_info_revenue_ofcompany` }),
    },
    {
      title: formatMessage({ id: `dbi_company_download_company` }),
      value: 'download_company',
      width: 275,
      width_cn: 275,
      renderType: RenderType.GROWTH_ONLY,
      textContent: formatMessage({ id: `dbi_info_downloads_ofcompany` }),
    },
  ];

  const revenueTrendList = generateList(revenueDownloadList, [
    'revenue',
    'download',
  ]);
  const downloadTrendList = generateList(revenueDownloadList, [
    'download',
    'revenue',
  ]);
  const revenueGameCountryList = generateList(revenueDownloadList, [
    'revenue',
    'revenue_company',
    'download',
  ]);
  const downloadGameCountryList = generateList(revenueDownloadList, [
    'download',
    'download_company',
    'revenue',
  ]);
  const mobileMetricsColumnsList = {
    trend: {
      download: downloadTrendList,
      revenue: revenueTrendList,
    },
    gameCountry: {
      download: downloadGameCountryList,
      revenue: revenueGameCountryList,
    },
  } as any;

  const digitalRevenueList = [
    {
      // text: 'Digital Revenue($)',
      text: formatMessage({ id: `dbi_metric_digitalRevenue` }),
      title: formatMessage({ id: `dbi_metric_digitalRevenueNoDo` }),
      value: 'digitalRevenue',
      dataSource: 'mscience',
      info: formatMessage({ id: `dbi_info_sum_selected` }),
      renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
      width: 230,
    },
    {
      // text: 'Units',
      text: formatMessage({ id: `dbi_metric_units` }),
      title: formatMessage({ id: `dbi_metric_units` }),
      value: 'units',
      dataSource: 'mscience',
      info: formatMessage({ id: `dbi_info_units_indicates` }),
      renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
      width: 180,
    },
    {
      text: formatMessage({ id: `dbi_company_revenue_company` }),
      value: 'digitalOfCompany',
      dataSource: 'mscience',
      info: formatMessage({ id: `dbi_info_revenue_ofcompany` }),
      renderType: RenderType.GROWTH_ONLY,
      width: 275,
    },
    {
      text: formatMessage({ id: `dbi_company_revenue_company` }),
      value: 'revenueOfCompany',
      dataSource: 'mscience',
      info: formatMessage({ id: `dbi_info_revenue_ofcompany` }),
      renderType: RenderType.GROWTH_ONLY,
      width: 275,
    },
    {
      text: formatMessage({ id: `dbi_company_units_company` }),
      value: 'unitsOfCompany',
      dataSource: 'mscience',
      info: formatMessage({ id: `dbi_info_revenue_ofcompany` }),
      renderType: RenderType.GROWTH_ONLY,
      width: 265,
    },
  ];
  const digitalTrendRevenue = generateList(digitalRevenueList, [
    'digitalRevenue',
    'units',
  ]);
  const digitalRevenueGame = generateList(digitalRevenueList, [
    'digitalRevenue',
    'revenueOfCompany',
    'units',
  ]);
  const digitalRevenueCountry = generateList(digitalRevenueList, [
    'digitalRevenue',
    'digitalOfCompany',
    'units',
  ]);
  const unitsGameCountry = generateList(digitalRevenueList, [
    'digitalRevenue',
    'unitsOfCompany',
    'units',
  ]);

  const digitalColumnsList = {
    trend: {
      digitalRevenue: digitalTrendRevenue,
      units: digitalTrendRevenue,
    },
    game: {
      digitalRevenue: digitalRevenueGame,
      units: unitsGameCountry,
    },
    country: {
      digitalRevenue: digitalRevenueCountry,
      units: unitsGameCountry,
    },
  } as any;

  const physicalList = [
    {
      // text: 'Physical Revenue($)',
      text: formatMessage({ id: `dbi_metric_physical_revenue` }),
      value: 'revenue',
      dataSource: 'npd',
      info: formatMessage({ id: `dbi_info_sum_selected` }),
      renderType: RenderType.VALUE_AND_RATIO,
      width: 250,
    },
    {
      text: formatMessage({ id: `dbi_company_revenue_company` }),
      value: 'ofCompany',
      dataSource: 'npd',
      info: formatMessage({ id: `dbi_info_revenue_ofcompany` }),
      renderType: RenderType.GROWTH_ONLY,
      width: 275,
    },
  ];
  const physicalTrendList = generateList(physicalList, ['revenue']);
  const physicalGameList = generateList(physicalList, ['revenue', 'ofCompany']);

  const companyMAUList = [
    {
      // text: 'MAU',
      text: formatMessage({ id: `dbi_metric_mau` }),
      value: 'MAU',
      info: formatMessage({ id: `dbi_info_avg_selected` }),
      renderType: RenderType.VALUE_AND_RATIO,
      dataSource: 'newzoo',
      width: 180,
      width_cn: 230,
    },
  ];
  const companyPCUList = [
    {
      // text: 'PCU',
      text: formatMessage({ id: `dbi_metric_pcu` }),
      value: 'PCU',
      dataSource: 'steamcharts',
      info: formatMessage({ id: `dbi_info_pcu` }),
      renderType: RenderType.VALUE_AND_RATIO,
      width: 180,
    },
    {
      // text: 'ACU',
      text: formatMessage({ id: `dbi_metric_acu` }),
      value: 'ACU',
      dataSource: 'steamcharts',
      info: formatMessage({ id: `dbi_info_acu_avg` }),
      renderType: RenderType.VALUE_AND_RATIO,
      width: 180,
    },
  ];
  return {
    gamesStatsOptions,
    digitalTrendRevenue,
    mobileMetricsColumnsList,
    digitalColumnsList,
    physicalTrendList,
    physicalGameList,
    companyMAUList,
    companyPCUList,
  };
};
